<template>
  <v-card :class="{'elevation-0': showFlat}">
    <div class="text-xs-right" v-if="!showFlat">
      <v-btn @click="$emit('onCancel')" fab flat small>
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <v-card-text :class="{'pa-0': showFlat}">
      <form>
        <v-layout wrap row v-if="input">
          <v-flex xs12 sm6 class="form-control pa-1" :class="{'has-error': errors.has('phone')}">
            <label>{{$t('Phone')}}</label>
            <input
              :data-vv-as="$t('Phone')"
              v-validate="'required'"
              v-model="input.phoneno"
              class="form-control"
              type="text"
              name="phone"
            />
            <span class="text-error" v-if="errors.has('phone')">{{ errors.first('phone') }}</span>
          </v-flex>
          <v-flex xs3 sm3 class="form-control pa-1" :class="{'has-error': errors.has('age')}">
            <label>{{$t('Age')}}</label>
            <input
              :data-vv-as="$t('Age')"
              v-validate="'required'"
              :mask="'###'"
              name="age"
              maxlength="3"
              v-model.number="input.age"
              class="form-control"
              type="number"
            />
            <span class="text-error" v-if="errors.has('age')">{{ errors.first('age') }}</span>
          </v-flex>
          <v-flex xs9 sm6 class="form-control pa-1" :class="{'has-error': errors.has('province')}">
            <label>{{$t('Province')}}</label>
            <input
              :data-vv-as="$t('Province')"
              v-validate="'required'"
              name="province"
              v-model="input.province"
              class="form-control"
              type="text"
            />
            <span class="text-error" v-if="errors.has('province')">{{ errors.first('province') }}</span>
          </v-flex>
          <v-flex xs12 sm6 class="form-control pa-1" :class="{'has-error': errors.has('email')}">
            <label>{{$t('Email')}}</label>
            <input
              :data-vv-as="$t('Email')"
              v-validate="'required|email'"
              name="email"
              v-model="input.email"
              class="form-control"
              type="text"
            />
            <span class="text-error" v-if="errors.has('email')">{{ errors.first('email') }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{'has-error': errors.has('business_type')}"
          >
            <label>{{$t('Business Type')}}</label>
            <multiselect
              :data-vv-as="$t('Business Type')"
              v-validate="'required'"
              name="business_type"
              v-model="input.business_type"
              :options="options.businesstype"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              :placeholder="$t('Business Type')"
            >
              <template slot="singleLabel" slot-scope="props">{{$t(props.option)}}</template>
              <template slot="option" slot-scope="props">{{$t(props.option)}}</template>
            </multiselect>
            <span
              class="text-error"
              v-if="errors.has('business_type')"
            >{{ errors.first('business_type') }}</span>
          </v-flex>
          <v-flex xs12 sm5 class="form-control pa-1" :class="{'has-error': errors.has('suggest')}">
            <label>{{$t('How did you hear about us?')}}</label>
            <multiselect
              ref="suggest"
              :data-vv-as="$t('How did you hear about us?')"
              v-validate="'required'"
              name="suggest"
              v-model="input.suggest"
              :options="options.suggest"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
            ></multiselect>
            <span class="text-error" v-if="errors.has('suggest')">{{ errors.first('suggest') }}</span>
          </v-flex>
          <v-flex
            v-if="input.suggest == 'Other'"
            xs12
            sm12
            class="form-control pa-1"
            :class="{'has-error': errors.has('suggest_other')}"
          >
            <label>{{$t('Please identify(if available)')}}</label>
            <input
              :data-vv-as="$t('Other')"
              v-validate="'required_if:suggest,Other'"
              name="suggest_other"
              v-model="input.suggest_other"
              class="form-control"
              type="text"
            />
            <span
              class="text-error"
              v-if="errors.has('suggest_other')"
            >{{ errors.first('suggest_other') }}</span>
          </v-flex>
          <v-flex xs12 sm12 class="form-control pa-1" :class="{'has-error': errors.has('contact')}">
            <label>{{$t('Please leave your line ID in order to contact you back')}}</label>
            <autoresize-textarea
              :data-vv-as="$t('Contact')"
              name="contact"
              v-validate="{'required': ['btn_12month_extra_fb', '12233'].includes(params)}"
              v-model="input.contact"
            />
            <span class="text-error" v-if="errors.has('contact')">{{ errors.first('contact') }}</span>
          </v-flex>
          <v-flex
            xs12
            sm12
            class="form-control pa-1"
            :class="{'has-error': errors.has('Reason to Buy')}"
          >
            <label>{{$t(`Which of Zwiz's features helps you to make a purchase`)}}</label>
            <multiselect
              :data-vv-as="$t(`Reason to Buy`)"
              v-validate="'required'"
              name="Reason to Buy"
              v-model="input.reason_to_buy"
              :options="options.reason_to_buy"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
            >
              <template slot="singleLabel" slot-scope="props">{{$t(props.option)}}</template>
              <template slot="option" slot-scope="props">{{$t(props.option)}}</template>
            </multiselect>
            <span
              class="text-error"
              v-if="errors.has('Reason to Buy')"
            >{{ errors.first('Reason to Buy') }}</span>
          </v-flex>
        </v-layout>
      </form>
      <slot name="footer" class="text-xs-center" :saveData="saveData">
        <v-btn class dark color="primary" @click="saveData()" :loading="loading">{{$t('Save')}}</v-btn>
      </slot>
    </v-card-text>
  </v-card>
</template>

<script>
import Multiselect from 'vue-multiselect'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
export default {
  props: ['value', 'params', 'loading', 'isFlat'],
  inject: ['$validator'],
  data() {
    return {
      input: null,
      options: {
        reason_to_buy: [
          'Real-time Response',
          'Line chatbot',
          'status & Tag',
          'Broadcast (Customize)',
          'Shop service (unlimited)',
          'Import previous users',
          'AI Training',
          'Line notification',
          'Reply to a comment (selected posts)'
        ],
        businesstype: [
          'Accessory',
          'Application & Platform',
          'Automotive',
          'Agriculture',
          'Accommodation',
          'Beauty',
          'Blogger',
          'Construction',
          'Dental Clinic',
          'Education',
          'Electronics',
          'Event',
          'Fashion',
          'Finance & Investment',
          'Food & Beverage',
          'Gadget & IT',
          'Game',
          'Gold',
          'Health',
          'Insurance',
          'Lifestyle',
          'Logistics',
          'Media & Entertainment',
          'Medication',
          'Mom and Kids',
          'Online Marketing',
          'Property',
          'Packaging',
          'Restaurant',
          'Travel',
          'Others'
        ],
        suggest: ['Facebook', 'Google', 'Other']
      },
      input_cache: '',
      showFlat: false
    }
  },
  components: {
    Multiselect,
    AutoresizeTextarea
  },
  mounted() {
    let vm = this
    this.input = this.value
    this.showFlat = this.isFlat || false
  },
  methods: {
    async saveData() {
      let result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.$emit('onSave')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/elements/PaymentForm.vue